import Locale from '../translations';
import { Link } from 'react-router-dom';
export default function Footer(props) {
  const { messages } = Locale;
  return (
    <footer className="footer p-4 mt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <img
              src="./images/malaeb.png"
              className="img-fluid mx-auto d-block"
              alt="img"
            />
            <p className="text-center">{messages.downloadApp}</p>
            <p className="text-center">
              <a href="https://play.google.com/store/apps/details?id=com.malaebapp.app">
                <img
                  src="./images/googleplay.png"
                  className="me-2 imgSocial"
                  alt="img"
                />
              </a>
              <a href="https://itunes.apple.com/us/app/malaeb-app/id1094201670?ls=1&mt=8">
                <img
                  src="./images/appstore.png"
                  className="imgSocial"
                  alt="img"
                />
              </a>
            </p>
            <p className="text-center pt-3">
              <a href="/#">
                <img src="./images/facebook.png" className="mx-3" alt="img" />
              </a>
              <a href="/#">
                <img src="./images/twitter.png" className="mx-3" alt="img" />
              </a>
              <a href="/#">
                <img src="./images/instagram.png" className="mx-3" alt="img" />
              </a>
            </p>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 ps-lg-5 willHide">
            <h6 className="pt-4">{messages.aboutMalaeb}</h6>
            <p>
              <Link to="/about">{messages.aboutUs}</Link>
            </p>
            <p>
              <Link to="/terms">{messages.termsAndConditions}</Link>
            </p>
            {/* <p>
              <a href="/#">{messages.howItWorks}</a>
            </p> */}
            {/* <p>
              <a href="/#">{messages.careers}</a>
            </p> */}
            <p>
              <Link to="/contact-us">{messages.contactUs}</Link>
            </p>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 willHide">
            <h6 className="pt-4">{messages.malaebForPlayer}</h6>
            <p>
              <Link to="/list">{messages.stadiumsList}</Link>
            </p>
            <p>
              <a href="/privacy">{messages.privacyPolicy}</a>
            </p>
            <p>
              <a href="/refund-policy">{messages.refundPolicy}</a>
            </p>
          </div>
          <div className="col-lg-3 col-md-6 col-sm-6 willHide">
           
            <h6 className="pt-4">{messages.malaebForOwners}</h6>
            <p>
              <a href="/#">{messages.joinAsOwner}</a>
            </p>
            <p>
              <Link to="/faqs">{messages.faqs}</Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
